import React from "react";

// const getGreeting = () => {
//   const h = new Date().getHours();
//   if (h < 12) return "Good Morning";
//   if (h < 17) return "Good Afternoon";
//   return "Good Evening";
// };

// Search/notifications/avatar already live in the app's main navbar — this
// is just the page-level greeting + subtitle + whatever date control the
// dashboard already has (passed through, not rebuilt here).
const DashboardHeader = ({ userName = "there", subtitle, dateControl }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: "12px",
        marginBottom: "16px",
      }}
    >
      <div>
        <h4 style={{ margin: 0, fontWeight: 700, color: "#111827" }}>
          {/* {getGreeting()}, {userName}! 👋 */}
        </h4>
        {/* <p style={{ margin: "2px 0 0", fontSize: "13px", color: "#6B7280" }}>
          {subtitle || "Here's what's happening with your business today."}
        </p> */}
      </div>

      {dateControl}
    </div>
  );
};

export default DashboardHeader;
